export default "__VITE_ASSET__B2ijLRq8__"